import { render, staticRenderFns } from "./ArticleMedia.vue?vue&type=template&id=4af259f6&scoped=true&"
import script from "./ArticleMedia.vue?vue&type=script&lang=js&"
export * from "./ArticleMedia.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMedia.vue?vue&type=style&index=0&id=4af259f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af259f6",
  null
  
)

export default component.exports